import React from 'react';
import { NavigationDots, SocialMedia } from '../components';

const AppWrap = (
  Component,
  idName,
  classNames,
  showSocial = true,
  showNavDots = true,
  showCopyright = true
) =>
  function HOC() {
    return (
      <div id={idName} className={`app__container ${classNames}`}>

        {/* Social Media (Separate Control) */}
        {showSocial && <SocialMedia />}

        <div className="app__wrapper app__flex">
          <Component />

          {/* COPYRIGHT */}
          {showCopyright && (
            <div className="copyright">
              <p className="p-text">@2025 GOMAL STUDIO</p>
              <p className="p-text">All rights reserved</p>
            </div>
          )}
        </div>

        {/* Navigation Dots (Separate Control) */}
        {showNavDots && <NavigationDots active={idName} />}

      </div>
    );
  };

export default AppWrap;
